// ** React Imports
import { Suspense, lazy } from 'react'
import ReactDOM from 'react-dom'
import { BrowserRouter } from 'react-router-dom'

import SocketProvider from './socket';

// ** Redux Imports
import { store, persistor } from './redux/storeConfig/store'
import { Provider } from 'react-redux'
import { PersistGate } from 'redux-persist/integration/react';
import AppProvider from './context/AppProvider';
import NetworkProvider from '@hooks/useNetworkV2';

// ** Intl, CASL & ThemeColors Context
import ability from './configs/acl/ability'
import { AbilityContext } from './utility/context/Can'
import { ThemeContext } from './utility/context/ThemeColors'

// ** ThemeConfig
import themeConfig from './configs/themeConfig'

// ** Toast
import { Toaster } from 'react-hot-toast'

// ** i18n
import './configs/i18n'

// ** Spinner (Splash Screen)
import Spinner from './@core/components/spinner/Fallback-spinner'

// ** Ripple Button
import './@core/components/ripple-button'

// ** Fake Database
import './@fake-db'

// ** PrismJS
import 'prismjs'
import 'prismjs/themes/prism-tomorrow.css'
import 'prismjs/components/prism-jsx.min'

// ** React Perfect Scrollbar
import 'react-perfect-scrollbar/dist/css/styles.css'

// ** React Hot Toast Styles
import '@styles/react/libs/react-hot-toasts/react-hot-toasts.scss'
import { ToastContainer}from 'react-toastify'
// ** Core styles
import './@core/assets/fonts/feather/iconfont.css'
import './@core/scss/core.scss'
import './assets/scss/style.scss'

// ** Service Worker
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
// ** Lazy load app
const LazyApp = lazy(() => import('./App'))

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <SocketProvider />
        <NetworkProvider />
        <Suspense fallback={<Spinner />}>
          <AbilityContext.Provider value={ability}>
            <AppProvider>
              <ThemeContext>
                <LazyApp />
                <Toaster position={themeConfig.layout.toastPosition} toastOptions={{ className: 'react-hot-toast' }} />
                {/* <ToastContainer/> */}
              </ThemeContext>
            </AppProvider>
          </AbilityContext.Provider>
        </Suspense>
      </PersistGate>
    </Provider>
  </BrowserRouter>, document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorkerRegistration.register()
